import { useEffect, useState } from "react";
import {Button, Container, Nav, Table} from "react-bootstrap";
import { Pen, PlusCircle, Trash } from "react-bootstrap-icons";
import { apiService } from '../../functions/api-service';
import Swal from 'sweetalert2';
import { Alert } from '../../functions/utils';
import { useContexts } from "../../context/AppContext";
import { Department } from "../../type";
import ModalDept from "../../components/modalDept";
import {useNavigate} from "react-router-dom";

export default function SettingDept() {
  const { isLoad, isLoaded } = useContexts();
  const [deptList, setDeptList] = useState<Array<Department>>([]);
  const [search, setSearch] = useState("");
  const filteredItems = deptList.filter(
    (item) => (item.name && item.name.toString().includes(search))
  );
  const [openFormDept, setOpenFormDept] = useState<{
    show: boolean;
    data: Department | null;
    saved: boolean
  }>({ show: false, data: null, saved: false });
  const {profile } = useContexts();

  useEffect(() => {
    getDeptList().catch(console.error);
    if((profile?.sub !== '0')){
      navigate("/setting")
    }
  }, []);

  useEffect(() => {
    if(openFormDept.saved){
      getDeptList().catch(console.error);
      setOpenFormDept((prev) => ({
        ...prev,
        saved: false,
      }))
    }
}, [openFormDept.saved]);

  const getDeptList = async () => {
    isLoad();
    setDeptList(await apiService.deptList({status: '1'}));
    isLoaded();
  };

  const removeDept = async (data: Department) => {
    await Swal.fire({
      title: `ต้องการลบ ${data.name}`,
      showCancelButton: true,
      confirmButtonText: "ลบ",
      cancelButtonText: "ปิด",
    }).then(async (result) => {
      if (result.isConfirmed && data.id) {
        const res = await apiService.removeDept(data.id);
        if (res.success === true) {
          getDeptList().then();
        }
        Alert(res.success, res.message);
      }
    });
  };

  const navigate = useNavigate();
  return (
    <Container className={"mw-100"}>
      <Nav variant="tabs" defaultActiveKey="/setting/dept">
        <Nav.Item>
          <Nav.Link onClick={() => navigate("/setting/person")} >Person</Nav.Link>
        </Nav.Item>
        <Nav.Item>
          <Nav.Link onClick={() => navigate("/setting/prefix")}  >Prefix</Nav.Link>
        </Nav.Item>
        <Nav.Item>
          <Nav.Link className={"active"} onClick={() => navigate("/setting/dept")}  >Departments</Nav.Link>
        </Nav.Item>
        <Nav.Item>
          <Nav.Link  onClick={() => navigate("/setting/treatment")}  >Regimen</Nav.Link>
        </Nav.Item>
      </Nav>
      <div>
        <h2>รายการแผนก</h2>
        <div  className="mb-2">ค้นหาข้อมูลได้จาก รหัส และชื่อ</div>
        <div className="mb-2 row">
          <div className={"col-10"}>
          <input className={"form-control"} type="text" placeholder="ค้นหา.." onChange={(e) => setSearch(e.target.value)} />
          </div>
          <div className={"col-2 d-grid"}>
            <Button variant="success" onClick={() => setOpenFormDept({ show: true, data: null, saved: false })}><PlusCircle /> เพิ่มข้อมูล</Button>
          </div>
        </div>
        <Table striped bordered hover>
          <thead>
            <tr>
              <th>รหัส</th>
              <th>ชื่อ</th>
              <th>แก้ไข</th>
            </tr>
          </thead>
          <tbody>
            {filteredItems.map((r) => (
              <tr>
                <td>{r.code}</td>
                <td>{r.name}</td>
                <td className={"text-center"}>
                  <Button
                    size="sm"
                    onClick={() => setOpenFormDept({ show: true, data: r, saved: false })}
                  >
                    <Pen />
                  </Button>{" "}
                  <Button variant="danger" size="sm" onClick={() => removeDept(r).then()}>
                    <Trash />
                  </Button>
                </td>
              </tr>
            ))}
          </tbody>
        </Table>
        <ModalDept
          show={openFormDept.show}
          data={openFormDept.data}
          handleClose={() =>
            setOpenFormDept((prev) => ({
              ...prev,
              show: false,
            }))
          }
          saved={() =>
            setOpenFormDept((prev) => ({
              ...prev,
              saved: true,
            }))}
        />
      </div>
      </Container>
  );
}
